const HTTP_ERROR_EVENT = 'app:http-error';

export function emitHttpError(detail) {
    if (typeof window === 'undefined') {
        return;
    }

    window.dispatchEvent(
        new CustomEvent(HTTP_ERROR_EVENT, {
            detail,
        })
    );
}

export function onHttpError(listener) {
    if (typeof window === 'undefined') {
        return () => {};
    }

    const handler = event => listener(event.detail);
    window.addEventListener(HTTP_ERROR_EVENT, handler);

    return () => {
        window.removeEventListener(HTTP_ERROR_EVENT, handler);
    };
}
